module.exports = __webpack_public_path__ + "img/arrow-up.2bb97894.png";